import loaderIcon from './../images/loading-gif-png-4.gif';

export default function Loader() {
    return (
        <img src={loaderIcon} alt="Loader" />
    )
}
